import React, { FC } from "react";
import { Tag, TagProps } from "antd";
import { clsx } from "clsx";
import { roundToTwoDecimals } from "../Number";
import { getScoreGrade } from "../Grade";
import { SvgIcon } from "./SvgIcon";
import classes from "./ScoreTag.module.less";

const getScoreText = (score: number, denominator: number, type: ScoreTagProps["type"]) => {
    switch (type) {
        case "decimal":
            return score;
        case "fraction":
            return `${score} / ${denominator}`;
        case "percentage":
            return `${score}%`;
    }
};

interface ScoreTagProps extends TagProps {
    score?: number;
    type?: "decimal" | "fraction" | "percentage";
    denominator?: number;
    filled?: boolean;
    showGrade?: boolean;
    showIcon?: boolean;
}

export const ScoreTag: FC<ScoreTagProps> = ({
    score = 0,
    type = "decimal",
    denominator = 100,
    filled,
    showGrade,
    showIcon,
    ...props
}) => {
    const _score = roundToTwoDecimals(score);
    const scoreText = getScoreText(_score, denominator, type);
    const gradeInfo = getScoreGrade(_score, denominator);
    const grade = showGrade ? `(${gradeInfo.grade})` : "";
    const color = filled ? gradeInfo.filledColor : gradeInfo.tag;
    const content = [scoreText, grade].join(" ").trim();

    const icon = showIcon ? (props.icon ?? <SvgIcon name="star" size={12} />) : null;

    const className = clsx(props.className, filled && classes.filled);

    return (
        <Tag {...props} color={color} className={className}>
            {icon} {content}
        </Tag>
    );
};
